import * as z from 'zod';
import { addressSchema } from '../../address/address.mjs';

const contractRolesBeforeOther = ["project_owner", "lender", "gc"];
const commercialRoles = ["federal_agency", "state_agency", "municipality"];
const otherRole = "other";
var Obligee;
(function (Obligee) {
    Obligee.contractRoleDef = [...contractRolesBeforeOther, otherRole];
    Obligee.commercialRoleDef = commercialRoles;
    Obligee.roleDef = [...contractRolesBeforeOther, ...commercialRoles, otherRole];
    Obligee.roleSchema = z.enum(Obligee.roleDef);
    Obligee.Role = Obligee.roleSchema.enum;
    const roleLabel = {
        project_owner: "Project Owner",
        lender: "Lender",
        gc: "General Contractor",
        federal_agency: "Federal Agency",
        state_agency: "State Agency",
        municipality: "Municipality",
        other: "Other",
    };
    const roleOption = (role) => ({ value: role, label: roleLabel[role] });
    Obligee.contractRoleOptions = Obligee.contractRoleDef.map(roleOption);
    Obligee.roleOptions = Obligee.roleDef.map(roleOption);
    Obligee.schema = z.object({
        name: z.string(),
        address: addressSchema,
        role: Obligee.roleSchema,
    });
})(Obligee || (Obligee = {}));

export { Obligee };
